import { useState } from "react";
import { MdAdd } from "react-icons/md";
import NewGoodsReceived from "../ArticleManagement/NewGoodsReceived";
import "./GoodsReceived.scss";

function getCurrentMonthRange() {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();
  const first = new Date(year, month, 1);
  const last = new Date(year, month + 1, 0);
  const format = (date: Date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const monthStr = String(date.getMonth() + 1).padStart(2, "0");
    return `${day}.${monthStr}.${date.getFullYear()}`;
  };
  return `${format(first)} - ${format(last)}`;
}

export default function GoodsReceived() {
  const [isNewGoodsReceivedOpen, setIsNewGoodsReceivedOpen] = useState(false);
  const [period] = useState(getCurrentMonthRange);
  const [status, setStatus] = useState("Alle");
  const [source, setSource] = useState("Alle");
  const [searchTerm, setSearchTerm] = useState("");
  const [imei, setImei] = useState("");
  const [searchInNotes, setSearchInNotes] = useState(false);

  function handleReset() {
    setStatus("Alle");
    setSource("Alle");
    setSearchTerm("");
    setImei("");
    setSearchInNotes(false);
  }

  return (
    <section className="sales-layout__page goods-received" aria-labelledby="goods-received-title">
      <div className="goods-received__layout">
        <div className="goods-received__main">
          <div className="goods-received__top-row">
            <header className="goods-received__header">
              <h1 id="goods-received-title">Alle Wareneingänge(0)</h1>
              <p>Übersicht aller eingegangenen Waren und Erfassung neuer Eingangslieferungen.</p>
            </header>

            <div className="goods-received__primary">
              <button
                type="button"
                className="goods-received__btn-action goods-received__btn-action--primary"
                onClick={() => setIsNewGoodsReceivedOpen(true)}
              >
                <MdAdd aria-hidden="true" /> Neue Eingangslieferungen
              </button>
            </div>
          </div>
        </div>

        <aside className="goods-received__filters" aria-labelledby="goods-received-filters-title">
          <h2 id="goods-received-filters-title" className="goods-received__filters-title">
            Filter
          </h2>

          <div className="goods-received__field">
            <label htmlFor="goods-received-period">Datum auswählen</label>
            <p id="goods-received-period" className="goods-received__period">
              {period}
            </p>
          </div>

          <div className="goods-received__field">
            <label htmlFor="goods-received-status">Status</label>
            <select
              id="goods-received-status"
              name="status"
              value={status}
              onChange={(event) => setStatus(event.target.value)}
            >
              <option value="Alle">Alle</option>
              <option value="Offen">Offen</option>
              <option value="Gebucht">Gebucht</option>
              <option value="Storniert">Storniert</option>
            </select>
          </div>

          <div className="goods-received__field">
            <label htmlFor="goods-received-source">Quelle</label>
            <select
              id="goods-received-source"
              name="source"
              value={source}
              onChange={(event) => setSource(event.target.value)}
            >
              <option value="Alle">Alle</option>
              <option value="Distributor">Distributor</option>
              <option value="Hersteller">Hersteller</option>
              <option value="Manuell">Manuell</option>
            </select>
          </div>

          <div className="goods-received__field">
            <label htmlFor="goods-received-search">Suchen</label>
            <input
              id="goods-received-search"
              name="search"
              type="search"
              placeholder="Suchen"
              value={searchTerm}
              onChange={(event) => setSearchTerm(event.target.value)}
            />
          </div>

          <div className="goods-received__field">
            <label htmlFor="goods-received-imei">Seriennummer / IMEI</label>
            <input
              id="goods-received-imei"
              name="imei"
              type="text"
              inputMode="numeric"
              placeholder="Seriennummer oder IMEI"
              value={imei}
              onChange={(event) => setImei(event.target.value)}
            />
          </div>

          <label className="goods-received__switch">
            <input
              type="checkbox"
              name="searchInNotes"
              role="switch"
              checked={searchInNotes}
              onChange={(event) => setSearchInNotes(event.target.checked)}
            />
            <span className="goods-received__switch-track" aria-hidden="true" />
            <span>in Notizen suchen</span>
          </label>

          <div className="goods-received__filter-actions">
            <button
              type="button"
              className="goods-received__btn-action goods-received__btn-action--secondary"
            >
              Suchen
            </button>
            <button
              type="button"
              className="goods-received__btn-action goods-received__btn-action--danger"
              onClick={handleReset}
            >
              Zurücksetzen
            </button>
          </div>
        </aside>
      </div>

      {isNewGoodsReceivedOpen && <NewGoodsReceived onClose={() => setIsNewGoodsReceivedOpen(false)} />}
    </section>
  );
}
